import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
declare var setSmartechEnable;

@Injectable()
export class NotificationService {
smartechEnabled:boolean = setSmartechEnable;

  tosterSettings  = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": true,
  "progressBar": true,
  "positionClass": this.smartechEnabled ? 'toast-top-full-width' : 'toast-bottom-full-width',
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": 800,
  "hideDuration": 1000,
  "timeOut": 7000,
  "extendedTimeOut": 1000,
  "showEasing": "swing",
  "hideEasing": "linear",
  "enableHtml" : true,
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut",

}
  constructor(private toastr: ToastrService) { }

  showSuccess(message, title=''){
      this.toastr.success(message, title, this.tosterSettings);
  }

  showError(message,title=''){
  	this.toastr.error(message, title, this.tosterSettings );

  }
  showWarning(message,title=''){
    this.toastr.warning(message, title, this.tosterSettings );

  }
  showInfo(message,title=''){
    this.toastr.info(message, title, this.tosterSettings );

  }
}
